//=====================================================
//　共通関数
//=====================================================

import { RefObject } from "react";

//-----------------------------------------------------
//　数値のゼロパディング整形
//  target：数値
//  digit：パディング桁数
//-----------------------------------------------------
export function zeroPadding(target: number, digit: number){
    return (Array(digit).join('0') + target).slice(-digit);
}

//-----------------------------------------------------
//　日付のフォーマット整形
//  fromTimeMark：「～」を表示するか
//-----------------------------------------------------
export function formatDate(val: Date, fromTimeMark: boolean){

    //「～」の表示
    let mark = "";
    if (fromTimeMark){
        mark = "～";
    }

    //曜日の変換
    const weeks:string[] = ["日", "月", "火", "水", "木", "金", "土"];

    return val.getFullYear() + "年" + zeroPadding(val.getMonth() + 1, 2) + "月" + zeroPadding(val.getDate(), 2) + "日" 
        + "(" + weeks[val.getDay()] + ") " + zeroPadding(val.getHours(), 2) + ":" + zeroPadding(val.getMinutes(), 2) + mark;

}
//-----------------------------------------------------
//　文字列を日付に整形
//  yyyy年mm月dd日(曜日) hh:mm から
//  yyyy/mm/dd hh:mm に整形
//-----------------------------------------------------
export function formatString(date: String){

    //曜日を除去し、日付型に整形
    const tmpYear = date.split("年")[0];
    const tmpMoth = date.split("年")[1].split("月")[0];
    const tmpDay = date.split("年")[1].split("月")[1].split("日")[0]
    const tmpTime = date.split(" ")[1]

    return new Date(tmpYear + "/" + tmpMoth + "/" + tmpDay + " " + tmpTime);

}

//-----------------------------------------------------
//　日付を文字列に整形
//  Date型の値 から
//  yyyy/mm/dd hh:mmの文字列に整形
//-----------------------------------------------------
export function formatDateTime(val: Date){

    return val.getFullYear() + "/" + (val.getMonth() + 1)  + "/" + val.getDate() 
        + " " + val.getHours() + ":" + ("00" + val.getMinutes()).slice(-2);

}

//----------------------------------------------------
//日付を整形
//
//YYYYMMの文字列に整形
//-----------------------------------------------------
export function formatDateMonth(val: Date){

    var getFullYear = val.getFullYear();
    var getMonth    = ("0"+(val.getMonth() + 1)).slice(-2);
    
    return getFullYear + getMonth;
}

//----------------------------------------------------
//日付を整形
//
//YYYYMMDDの文字列に整形
//-----------------------------------------------------
export function formatDateWeek(val: Date){
    var getFullYear = val.getFullYear();
    var getMonth    = ("0"+(val.getMonth() + 1)).slice(-2);
    var getDate     = ("0"+val.getDate()).slice(-2);
    
    return getFullYear + getMonth + getDate;
    
}

//----------------------------------------------------
//8桁の日付文字列をDate型に変換
//-----------------------------------------------------
export function string8ToDate(val:string){
    var year = val.substring(0, 4);
    var month = val.substring(4, 6);
    var date = val.substring(6);
    return new Date(year + "-" + month + "-" + date);
}

//----------------------------------------------------
//Date型を8桁の日付文字列に変換
//-----------------------------------------------------
export function dateToString8(val:Date){
    var year = val.getFullYear().toString();
    var month = ("0" + (val.getMonth() + 1).toString()).slice(-2);
    var date = ("0" + val.getDate().toString()).slice(-2);
    return year + month + date;
}

//----------------------------------------------------
//8桁の日付文字列をyyyy/mm/dd（曜日）の形に変換
//-----------------------------------------------------
export function string8ToFormatDateString(val:string){
    var year = val.substring(0, 4);
    var month = val.substring(4, 6);
    var date = val.substring(6);
    var dayOfWeekStr = [ "日", "月", "火", "水", "木", "金", "土" ]
    var day = dayOfWeekStr[string8ToDate(val).getDay()];
    return year + "/" + month + "/" + date + "（" + day + "）";
}


//----------------------------------------------------
//開始時間（hh:mm:ss）と終了時間（hh:mm:ss）の文字列から範囲表記に変換
//
//hh:mm - hh:mmを返す
//-----------------------------------------------------
export function getTimeRange(stime:string, etime:string){
    var shour = ("0" + stime.split(":")[0]).slice(-2);
    var sminutes = stime.split(":")[1];
    var ehour = ("0" + etime.split(":")[0]).slice(-2);
    var eminutes = etime.split(":")[1];
    return shour + ":" + sminutes + " - " + ehour + ":" + eminutes;
}

//-----------------------------------------------------
//時間の表記フォーマットをhh:ssの形に整形する
//-----------------------------------------------------
export function formatTime(time:string){
    var hour = ("0" + time.split(":")[0]).slice(-2);
    var minutes = time.split(":")[1];
    return hour + ":" + minutes;
}

//-----------------------------------------------------
//文字列の時間hh:mmを日付型（今日のhh:mm:00時）にして返す
//-----------------------------------------------------
export function stringToTime(time:string){
    let tmpTime = new Date();
    tmpTime.setHours(Number(time.substring(0, 2)));
    tmpTime.setMinutes(Number(time.substring(3, 5)));
    tmpTime.setSeconds(0);
    return tmpTime;
}


//----------------------------------------------------
//Date型をyyyy/mm/ddの文字列に変換
//-----------------------------------------------------
export function getDateToString(val:Date){
    var year = val.getFullYear().toString();
    var month = ("0" + (val.getMonth() + 1).toString()).slice(-2);
    var date = ("0" + val.getDate().toString()).slice(-2);
    return year + "/" + month + "/" + date;
}


//----------------------------------------------------
//金額フォーマットを数値に変換
//
//円とカンマを除去
//-----------------------------------------------------
export function priceToNumber(val: string):number{
    return Number(val.replace("円", "").replaceAll(",", ""))
}

//----------------------------------------------------
//数値を金額フォーマットに変換
//
//円とカンマを付与
//----------------------------------------------------
export function numberToPrice(val: Number):string{
    return val.toLocaleString() + "円"
}

//----------------------------------------------------
// スペース区切りの文字列を分割取得しv(引数)番目の値を返す
//----------------------------------------------------
export function spaceSplit(s: string, v: number){
    const name = s.split(" ");
    return name[v]
}

//----------------------------------------------------
// 「:」区切りの文字列を分割取得しv(引数)番目とv2(引数)番目の値を返す
//----------------------------------------------------
export function conmaSplit(s: string, v: number, n: number){
    const date = s.split(":");
    return (date[v] + ":" + date[n])
}

//----------------------------------------------------
// 年・月・日を「-」区切りで取得
// 時・分を「:」区切りで取得
//----------------------------------------------------
export function getCurrentTime(date: Date) {
    var res = "" + String(date.getFullYear()) + "-" + String(date.getMonth() + 1 ).padStart(2,'0') + 
        "-" + String(date.getDate()).padStart(2,'0') + " " + String(date.getHours()).padStart(2,'0') + ":" + 
        String(date.getMinutes()).padStart(2,'0') + ":" + String(date.getSeconds()).padStart(2,'0');

    return res;
}

//----------------------------------------------------
//連想配列の空を判定する
//{} ⇒ true
//{a:"aaa", b:"bbb"} ⇒ false
//----------------------------------------------------
export function isEmptyArrayHash(val:any){
    if (Object.keys(val).length > 0){
        return false;
    } else {
        return true;
    }
}

//----------------------------------------------------
//途中リロード対策
//リロードしようとした際にメッセージを表示する
//----------------------------------------------------
export function reloadBlock(e:any){
    e.preventDefault();
    e.returnValue = '';
}


//----------------------------------------------------
//画面の一番上を表示する
//pushで画面を切り替えるとスクロール位置が引き継がれたままなので、
//それを解除する時等に使ってください。
//----------------------------------------------------
export function scrollTop(){
    window.scrollTo(0, 0);
}


//----------------------------------------------------
//画面の情報を埋め込み先ページに渡す
//----------------------------------------------------
export function sendWindowHeight(ref: RefObject<HTMLDivElement>){
    let clientHeight = 0;
    if (ref.current){
        clientHeight = ref.current.clientHeight
    }
    window.parent.postMessage({height:clientHeight}, process.env.REACT_APP_HOMEPAGEURL + "");
}